import type { DifficultyId } from '../types/primitives'
import type { StageDifficultyClears } from './stars'
import { applyDifficultyClear } from './stars'

/** First-clear Ingots amounts per difficulty (granted by progression layer). */
export interface StageFirstClearRewards {
  easy: number
  normal: number
  hard: number
  insane: number
}

export interface FirstClearResolution {
  /** Difficulties whose first-clear reward should grant now. */
  newlyCleared: DifficultyId[]
  /** Sum of reward amounts for those difficulties (Ingots units — not paid out in M42). */
  totalRewardAmount: number
  /** Updated granted mask after this resolution. */
  granted: StageDifficultyClears
}

/**
 * Idempotent first-clear resolution.
 * Insane-first grants Easy+Normal+Hard+Insane rewards once.
 * Second clear of same/higher difficulty grants nothing.
 */
export function resolveFirstClearRewards(
  alreadyGranted: StageDifficultyClears,
  cleared: DifficultyId,
  rewards: StageFirstClearRewards
): FirstClearResolution {
  const afterCascade = applyDifficultyClear(emptyGranted(), cleared)
  const newlyCleared: DifficultyId[] = []
  let totalRewardAmount = 0
  const granted = { ...alreadyGranted }

  const order: DifficultyId[] = ['easy', 'normal', 'hard', 'insane']
  for (const id of order) {
    if (afterCascade[id] && !alreadyGranted[id]) {
      newlyCleared.push(id)
      totalRewardAmount += rewards[id]
      granted[id] = true
    }
  }

  return { newlyCleared, totalRewardAmount, granted }
}

function emptyGranted(): StageDifficultyClears {
  return { easy: false, normal: false, hard: false, insane: false }
}
